import axios from "axios";
const apiAdder = process.env.VUE_APP_API;
export async function sendNumber(_, sendData) {
  return axios.post(`${apiAdder}user/register/`, sendData).then((rsp) => {
    return rsp.data;
  });
}

export async function confermCode(_, data) {
  return axios.post(`${apiAdder}user/confirm/`, data).then((rsp) => {
    return rsp.data;
  });
}

export async function profile() {
  const token = localStorage.getItem("token");
  let config = {
    headers: { authorization: `Bearer ${token}` },
  };
  return axios.get(`${apiAdder}user/profile/`, config).then((rsp) => {
    return rsp.data;
  });
}

export async function updateProfile(_, data) {
  const token = localStorage.getItem("token");
  let config = {
    headers: { authorization: `Bearer ${token}` },
  };
  return axios.patch(`${apiAdder}user/profile/`, data, config).then((rsp) => {
    return rsp.data;
  });
}

export async function setNationalCode(_, data) {
  const token = localStorage.getItem("token");
  let config = {
    headers: { authorization: `Bearer ${token}` },
  };
  return axios
    .post(`${apiAdder}user/national-code/`, data, config)
    .then((rsp) => {
      return rsp.data;
    });
}

export async function getNotificationSettingList() {
  const token = localStorage.getItem("token");
  let config = {
    headers: { authorization: `Bearer ${token}` },
  };
  return axios.get(`${apiAdder}notification-settings/`, config).then((rsp) => {
    return rsp.data;
  });
}

export async function getNotificationSetting(_, id) {
  const token = localStorage.getItem("token");
  let config = {
    headers: { authorization: `Bearer ${token}` },
  };
  return axios
    .get(`${apiAdder}notification-settings/${id}/`, config)
    .then((rsp) => {
      return rsp.data;
    });
}

export async function updateNotificationSetting(_, data) {
  const token = localStorage.getItem("token");
  let config = {
    headers: { authorization: `Bearer ${token}` },
  };
  return axios
    .patch(`${apiAdder}notification-settings/${data.pk}/`, data.data, config)
    .then((rsp) => {
      return rsp.data;
    });
}

export async function getDevice() {
  const token = localStorage.getItem("token");
  let config = {
    headers: { authorization: `Bearer ${token}` },
  };
  return axios.get(`${apiAdder}device/`, config).then((rsp) => {
    return rsp.data;
  });
}
